import { useEffect, useRef, useState } from 'react';
import { getSearchPreviewList } from '../api/services/productService';

const SEARCH_PREVIEW_DELAY = 250;

const isCanceledRequest = (error) =>
  error?.name === 'AbortError' ||
  error?.name === 'CanceledError' ||
  error?.code === 'ERR_CANCELED';

const useSearchPreview = ({ keyword, userInfo }) => {
  const [searchPreviewList, setSearchPreviewList] = useState([]);
  const latestRequestRef = useRef(0);

  useEffect(() => {
    const requestId = latestRequestRef.current + 1;
    latestRequestRef.current = requestId;

    const trimmedKeyword = keyword.trim();
    if (userInfo.userId == 0 || trimmedKeyword.length <= 1) {
      setSearchPreviewList([]);
      return undefined;
    }

    const abortController = new AbortController();
    const timeoutId = setTimeout(async () => {
      try {
        const result = await getSearchPreviewList(
          trimmedKeyword,
          userInfo.idCustomer,
          userInfo.brandId,
          userInfo.idStore,
          '01',
          abortController.signal,
        );

        if (latestRequestRef.current === requestId) {
          setSearchPreviewList(result.searchList || []);
        }
      } catch (error) {
        if (
          !isCanceledRequest(error) &&
          latestRequestRef.current === requestId
        ) {
          setSearchPreviewList([]);
        }
      }
    }, SEARCH_PREVIEW_DELAY);

    return () => {
      clearTimeout(timeoutId);
      abortController.abort();
    };
  }, [
    keyword,
    userInfo.brandId,
    userInfo.idCustomer,
    userInfo.idStore,
    userInfo.userId,
  ]);

  return searchPreviewList;
};

export default useSearchPreview;
